module.exports = __webpack_public_path__ + "img/scene_ocean_big@2x.6d895f8b.png";